module.exports = __webpack_public_path__ + "static/media/facebook-sketched-logo-variant.c0bfe8eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/facebook-sketched-logo-variant.svg
// module id = 219
// module chunks = 0